import { createIcon } from '../createIcon';

export const UnlockIconConfig = {
  name: 'UnlockIcon',
  height: 512,
  width: 448,
  svgPath: 'M144 144c0-44.2 35.8-80 80-80c31.9 0 59.4 18.6 72.3 45.7c7.6 16 26.7 22.8 42.6 15.2s22.8-26.7 15.2-42.6C331 33.7 281.5 0 224 0C144.5 0 80 64.5 80 144v48H64c-35.3 0-64 28.7-64 64V448c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V256c0-35.3-28.7-64-64-64H144V144z',
  yOffset: 0,
  xOffset: 0
};

export const UnlockIcon = createIcon(UnlockIconConfig);

export default UnlockIcon;